export const getFormData = (data) => {
  const bodyFormData = new FormData()
  // expedient
  if (data?.is_your_circulation_card) bodyFormData.append('is_your_circulation_card', data?.is_your_circulation_card)
  if (data?.type_of_invoice) bodyFormData.append('type_of_invoice', data?.type_of_invoice)
  if (data?.year) bodyFormData.append('year', data?.year)
  // documents
  if (data?.doc_type) bodyFormData.append('doc_type', data?.doc_type)
  if (data?.attachment) bodyFormData.append('attachment', data?.attachment)
  return bodyFormData
}
